import React, { Component } from "react";
import PubSub from "pubsub-js";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router";
import { bindActionCreators } from "redux";
import Home from "./pages/Home";
import CreateOffer from "./pages/CreateOffer";
import MyAccount from "./components/sidebar/MyAccount";
import {
	ROUTE_ACCOUNT_DETAILS,
	ROUTE_CREATE_OFFER,
	ROUTE_PREFIX_EDIT_OFFER,
	ROUTE_HOME,
	ROUTE_MY_PASSENGERS,
	ROUTE_RANKING,
	ROUTE_SALE,
	ROUTE_SALE_DETAILS,
	ROUTE_SALE_MILES,
	ROUTE_SMART_EXTRACT,
	ROUTE_ADVANCED_MANAGEMENT,
	ROUTE_LANDING_PAGE,
	ROUTE_IFRAME_OFFER,
	ROUTE_IFRAME_AMP_OFFER,
	ROUTE_REDIRECT_OFFER,
	ROUTE_REDIRECT_SIMULATOR,
	ROUTE_PREFIX_EDIT_OFFER_MOBILE,
	ROUTE_PREFIX_CREATE_OFFER_MOBILE,
	ROUTE_PREFIX_CREATE_OFFER,
	ROUTE_CREATE_OFFER_MOBILE
} from "./shared/constants";
import Sale from "./pages/Sale";
import SaleDetails from "./pages/SaleDetails";
import RankingPage from "./pages/RankingPage";
import { getUserToken } from "./shared/utils";
import { logoutUser, pingUser } from "./shared/requests-api";
import { redirectAfterLogout, redirectToLogin } from "../../js/shared/utils";
import { showOffers } from "./actions";
import { checkManager } from "./actions/advanced-management";
import { getRelationshipsParticipant } from "./actions/account-link";
import { getRelationships } from "./actions/advanced-management";
import AccountDetails from "./pages/AccountDetails";
import { isMobile } from "../../js/components/searchform/utils/common";
import SmartExtract from "./pages/SmartExtract";
import OffersLandingPage from "./pages/OffersLandingPage";
import MiniOffer from "./pages/MiniOffer";
import Passengers from "./pages/Passengers";
import AdvancedManagement from "./pages/AdvancedManagement";
import RedirectSimulator from "./pages/RedirectSimulator";
import RedirectOffer from "./pages/RedirectOffer";
import { ApiProvider } from "./services/api-hook";
import { NewOfferProvider } from "./context/new-offer";
import QuickOfferSection from "./components/organisms/QuickOfferSection";
import EditOfferMobile from "./components/new-offer-mobile/edit";
import CreateOfferMobile from "./components/new-offer-mobile/create";
import NewOffer from "./pages/NewOffer";
import { NewOfferMobileProvider } from "./components/new-offer-mobile/context";
import NewOfferMobile from "./components/new-offer-mobile/shared/NewOfferMobile/Index";
import NewOfferCreate from "./components/new-offer/NewOfferCreate";
import NewOfferEdit from "./components/new-offer/NewOfferEdit";
import { type } from "ramda";

class OffersAppRoutes extends Component {
	constructor(props) {
		super(props);

		let self = this;
		this.unlisten = this.props.history.listen((location, action) => {
			if (location.pathname == ROUTE_HOME && self.props.showOffers) {
				self.props.showOffers();
			}
		});
	}

	componentDidMount() {
		if (getUserToken()) {
			this.props.checkManager();
			this.props.getRelationshipsParticipant();
			this.props.getRelationships();
		}
		this.validateLogin(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this.validateLogin(nextProps);
	}

	componentWillUnmount() {
		if (this.unlisten) {
			this.unlisten();
		}
	}

	validateLogin(props) {
		if (window.isWebview) {
			// Não precisa validar se for webview
			return;
		}

		const { location } = props;
		const token = getUserToken();

		// Validar somente se estiver dentro da área de ofertantes /cliente/**
		if (location.pathname.indexOf("/cliente") !== -1) {
			pingUser(token)
				.then(response => {
					if (!response.data.success) {
						logoutUser()
							.then(() => {
								redirectAfterLogout(window);
							})
							.catch(error => {
								reject(error);
							});
					}
				})
				.catch(error => {
					logoutUser()
						.then(() => {
							redirectAfterLogout(window);
						})
						.catch(error => {
							reject(error);
						});
				});
		}
	}

	render() {
		const { location, history, typePhoneLatam } = this.props;
		if (location.pathname.toLowerCase() == ROUTE_LANDING_PAGE.toLowerCase()) {
			return <OffersLandingPage />;
		} else if (
			location.pathname.toLowerCase() == ROUTE_IFRAME_OFFER.toLowerCase() ||
			location.pathname.toLowerCase() == ROUTE_IFRAME_AMP_OFFER.toLowerCase()
		) {
			logoutUser();
			localStorage.removeItem("au"); // Sempre deslogado pro redirecionamento funcionar
			return <MiniOffer />;
		} else if (location.pathname.toLowerCase() == ROUTE_REDIRECT_SIMULATOR.toLowerCase()) {
			return <RedirectSimulator />;
		} else if (location.pathname.indexOf(ROUTE_SALE_MILES) != -1) {
			// Vender milhas página dedicada ao programa
			let acronym = location.pathname
				.split("/")
				.pop()
				.split("-")
				.shift();

			if (getUserToken()) {
				document.body.className = document.body.className.replace("dedicated-offer", "user-logged");
				history.push(ROUTE_REDIRECT_OFFER);
				localStorage.setItem("FidelityAcronym", acronym);
				return null;
			} else {
				document.body.className = document.body.className
					.replace("user-logged", "")
					.replace("dedicated-offer", "dedicated-offer dedicated-offer--program");
			}

			return (
				<div className="offers-row row no-margin">
					<div className={`col-xs-16 ${isMobile() ? "" : "no-padding"} col-md-8 col-md-offset-4`}>
						<CreateOffer acronym={acronym} dedicatedOffer={true} />
					</div>
				</div>
			);
		}

		/**
		 * a suíte de testes roda nesse endereço(about:blank).
		 * Quando importamos {store} e {history}, eles tentavam executar history.push() indevidamente,
		 * o que resultava em quebra dos testes.
		 * O if acima evita que o ambiente de testes execute um history.push indevido.
		 */
		if (window.location.href.match("about:blank") == null) {
			//window.history.pushState(ROUTE_CREATE_OFFER.toString(), document.title, location.pathname);
		}

		if (window.innerWidth < 768 && location.pathname === ROUTE_CREATE_OFFER) {
			if (history.action === "POP") {
				// Voltar mobile nao cair no desktop
				history.goBack();
			} else {
				history.push(ROUTE_CREATE_OFFER_MOBILE);
			}
		}

		return (
			<div className="offers-row row" style={isMobile() ? { overflow: "hidden" } : {}}>
				<div className="col-md-4 col-lg-3 left-menu">
					<MyAccount />
				</div>
				<div className={`col-md-12 col-lg-13 ${isMobile() ? "no-padding" : ""}`}>
					{/* TODO Refact api provider */}
					<ApiProvider>
						<NewOfferProvider>
							<NewOfferMobileProvider>
								<Switch>
									<Route exact path={`${ROUTE_HOME}`} component={Home} />
									<Route exact path={`${ROUTE_CREATE_OFFER_MOBILE}`} component={NewOfferMobile} />
									<Route exact path={`${ROUTE_CREATE_OFFER}`} component={NewOffer} />
									<Route
										path={`${ROUTE_PREFIX_EDIT_OFFER_MOBILE}/:path?`}
										render={props => <EditOfferMobile {...props} typePhoneLatam={typePhoneLatam} />}
									/>
									<Route path={`${ROUTE_PREFIX_EDIT_OFFER}/:path?`} component={NewOfferEdit} />
									<Route
										path={`${ROUTE_PREFIX_CREATE_OFFER_MOBILE}/:path?/:step?`}
										component={CreateOfferMobile}
									/>
									<Route path={`${ROUTE_PREFIX_CREATE_OFFER}/:path?`} component={NewOfferCreate} />
									<Route path={`${ROUTE_REDIRECT_OFFER}`} component={RedirectOffer} />
									<Route path={`${ROUTE_SMART_EXTRACT}`} component={SmartExtract} />
									<Route path={`${ROUTE_SALE}`} component={Sale} />
									<Route path={`${ROUTE_SALE_DETAILS}`} component={SaleDetails} />
									<Route path={`${ROUTE_RANKING}`} component={RankingPage} />
									<Route path={`${ROUTE_MY_PASSENGERS}`} component={Passengers} />
									<Route
										path={`${ROUTE_ACCOUNT_DETAILS}`}
										render={props => <AccountDetails {...props} typePhoneLatam={typePhoneLatam} />}
									/>
									<Route path={`${ROUTE_ADVANCED_MANAGEMENT}`} component={AdvancedManagement} />
									<Redirect from={`*`} to={`${ROUTE_HOME}`} />
								</Switch>
							</NewOfferMobileProvider>
						</NewOfferProvider>
					</ApiProvider>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	typePhoneLatam: state.createOffer.typePhoneLatam
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			showOffers,
			checkManager,
			getRelationshipsParticipant,
			getRelationships
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OffersAppRoutes));
